<div class="sidebar__body">
  <ng-content></ng-content>
</div>
